module.exports = __webpack_public_path__ + "img/feature_buy_th.1f1c68bb.png";